import { ObjectMapper } from "json-object-mapper";
import { InsightEmployeeModel } from "./insightEmployee.model";

export type InsightKeys = 'headcount' | 'turnover' | 'absenteism' | 'overtime' | 'comptime' | 'sesmt' | 'light-comptime' | 'light-overtime';

export type ChartKeys = 'sex' | 'seniorization' | 'ageRange' | 'timeCompanyRange' | 'educationLevel' | 'status' | 'disabilityType' | 'yearMonth' | 'scale' | 'countResignHiring' | 'reason';

export interface ItemCounterType {
  label: string,
  description: string,
  quantity: number,
  value: string,
  count: number
}

export interface CounterType {
  title: string,
  filterBy: string,
  count: any,
  countComparer: any,
  countComparerExact: any,
  countItems: ItemCounterType[],
  multiCount: any,
  chartName: string,
  version: number
}

export interface InsightPeriodOption {
  yearMonth: string;
  dateBegin: string;
  dateEnd: string;
}

export class InsightModel {
  employees: InsightEmployeeModel[] = [];
  totalizers: any[] = [];
  counters: CounterType[] = [];
  costCenters: string[] = [];
  groupCCs: string[] = [];
  companies: string[] = [];
  periods: InsightPeriodOption[] = [];
  summary: number = 0;
  shouldUpdate: boolean = false;

  static create(input: any): InsightModel {
    return ObjectMapper.deserialize<InsightModel>(InsightModel, input);
  }

  public toJSON(): string {
    return ObjectMapper.serialize(this) as string;
  }
}